module.exports = __webpack_public_path__ + "static/img/error-500.a371eab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-page/error-500.svg
// module id = MxJW
// module chunks = 1